import { Injectable } from "@angular/core";

const VERSION = 1;

type Area = "FrontOffice" | "BackOffice";
type Key = "InvDaily" | "Categories";

@Injectable({
  providedIn: "root",
})
export class IndexedDbService {
  db: IDBDatabase;

  constructor() {
    if (!window.indexedDB) {
      console.log("IndexedDB not available");
    } else {
      const openRequest = indexedDB.open("Sepidz", VERSION);
      openRequest.onerror = () => {
        console.log(openRequest.error);
      };
      openRequest.onsuccess = () => {
        this.db = openRequest.result;
      };
      openRequest.onupgradeneeded = () => {
        try {
          this.db = openRequest.result;
          if (!this.db.objectStoreNames.contains("FrontOffice")) {
            this.db.createObjectStore("FrontOffice");
          }
        } catch (error) {
          console.log(error);
        }
      };
    }
  }

  get(area: Area, key: Key): Promise<any> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([area], "readonly");
      const store = transaction.objectStore(area);
      const getRequest: IDBRequest<any> = store.get(key);
      getRequest.onerror = () => {
        console.log(getRequest.error);
        reject(getRequest.error);
      };
      getRequest.onsuccess = () => {
        const records = getRequest.result;
        if (!records) resolve(null);
        else resolve(getRequest.result);
      };
    });
  }

  put(area: Area, key: Key, value: unknown) {
    return new Promise((resolve, reject) => {
      const onError = (error) => {
        console.log(error);
      };
      try {
        const transaction = this.db.transaction([area], "readwrite");
        const store = transaction.objectStore(area);
        const putRequest = store.put(value, key);
        putRequest.onerror = () => {
          onError(putRequest.error);
          reject(putRequest.error);
        };
        putRequest.onsuccess = () => {
          resolve(putRequest.result);
        };
      } catch (err) {
        onError(err);
      }
    });
  }

  clear(area: Area, key: Key) {
    return new Promise((resolve, reject) => {
      const onError = (error) => {
        console.log(error);
      };
      try {
        const transaction = this.db.transaction([area], "readwrite");
        const store = transaction.objectStore(area);
        const deleteRequest = store.delete(key);
        deleteRequest.onerror = () => {
          onError(deleteRequest.error);
          reject(deleteRequest.error);
        };
        deleteRequest.onsuccess = () => {
          resolve(true);
        };
      } catch (err) {
        onError(err);
      }
    });
  }
}
